// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "action_item.proto" (syntax proto3)
// tslint:disable
import { ActionItem } from "./action_item";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service ActionItem
 */
export class ActionItemClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = ActionItem.typeName;
        this.methods = ActionItem.methods;
        this.options = ActionItem.options;
    }
    /**
     * @generated from protobuf rpc: CreateGeneratedTask
     */
    createGeneratedTask(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetGeneratedTask
     */
    getGeneratedTask(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetGeneratedTask
     */
    batchGetGeneratedTask(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateGeneratedTask
     */
    updateGeneratedTask(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteGeneratedTask
     */
    deleteGeneratedTask(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetImpliedTask
     */
    batchGetImpliedTask(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateGeneratedTaskDocument
     */
    createGeneratedTaskDocument(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetGeneratedTaskDocument
     */
    getGeneratedTaskDocument(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetGeneratedTaskDocument
     */
    batchGetGeneratedTaskDocument(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateGeneratedTaskDocument
     */
    updateGeneratedTaskDocument(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteGeneratedTaskDocument
     */
    deleteGeneratedTaskDocument(input, options) {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
